import React from 'react';
import FormControlLabelLayout from './FormControlLabelLayout';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { Checkbox, Divider, FormControlLabel } from '@material-ui/core';

const ShareFlagsListItem = ({
  item,
  itemInfo,
  handleItemListSelection,
  selectedListItems,
  isGroup,
  action
}) => {
  const { id, userId } = item;
  const { index, listLength } = itemInfo;

  const handleCheckedBoxes = () => {
    if (action === 'create') {
      return (
        selectedListItems.filter((item) => item.value === userId?.toString())
          ?.length > 0
      );
    }
    if (isGroup) {
      return selectedListItems.includes(id?.toString());
    } else {
      return selectedListItems.includes(userId?.toString());
    }
  };

  const onHandleChange = (event) => {
    handleItemListSelection({
      event,
      itemChipID: isGroup ? `G-${id}` : `U-${userId}`,
      type: isGroup ? 'group' : 'user'
    });
  };

  return (
    <>
      <FormControlLabel
        key={isGroup ? `G-${id}` : `U-${userId}`}
        control={
          <Checkbox
            className="share-flags-modal__checkbox"
            checked={handleCheckedBoxes()}
            onChange={(event) => onHandleChange(event)}
            value={isGroup ? id : userId}
            icon={<RadioButtonUncheckedIcon fontSize="large" />}
            checkedIcon={<RadioButtonCheckedIcon fontSize="large" />}
          />
        }
        label={<FormControlLabelLayout item={item} isGroup={isGroup} />}
        labelPlacement="start"
        className="share-flags-modal__form-label"
      />
      {index !== listLength - 1 && (
        <Divider
          className="share-flags-modal__divider"
          variant="middle"
          style={{ marginBottom: '6px' }}
        />
      )}
    </>
  );
};

export default ShareFlagsListItem;
